<template>
    <d-card class="h-100">
        <d-card-header :class="{ 'border-bottom success': keuze }" class="border-bottom">Keuze.nl</d-card-header>
        <d-card-body>
            <d-col class="d-flex justify-content-center">
                <img class="img-fluid" src="@/assets/images/keuze.svg" alt="keuze">
            </d-col>
        </d-card-body>
        <d-col class="mb-3" v-if="create == true">
            <keuze-connect-form :website-id="websiteId" />
        </d-col>
        <d-card-footer v-else class="d-flex justify-content-center">
            <button v-if="keuze" @click="showKeuzeForm" class="btn btn-secondary">Connected</button>
            <button v-else @click="connect" class="btn btn-success">Connect</button>
        </d-card-footer>
    </d-card>
</template>

<script>
    import KeuzeConnectForm from '@/views/integrations/keuze/ConnectForm.vue'
    import {ErrorService, KeuzeNLIntegration} from "@/main";
    import * as Sentry from "@sentry/browser";
    import notification from "@/mixins/notification";

    export default {
        props: ['keuze'],

        components: {
            KeuzeConnectForm,
        },
        mixins: [notification],

        data() {
            return {
                create: false,
                websiteId: this.$route.params.id
            };
        },

        methods: {
            showKeuzeForm() {
                this.create = true
            },

            async connect() {
                try {
                    await KeuzeNLIntegration.connect(this.websiteId)

                    this.showNotification('success', 'Alert', 'Keuze.NL successfully connected!')
                    this.$router.go()
                } catch(e) {
                    this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                    Sentry.captureException(e);
                }
            },
        },

        created() {
            this.isUpdate = !!this.keuze
        },

        beforeUpdate() {
            if (! this.isUpdate) {
                this.isUpdate = !!this.keuze // for already storing show update form
            }
        }
    };
</script>
